var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"container-video-js"}},[_c('video',{staticClass:"video-js vjs-custom-skin vjs-overlay",attrs:{"id":_vm.videoId,"controls":"","preload":"metadata"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }